import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import SaveButton from '@ui-elements/SaveButton';
import BasicModal from '@ui-parts/BasicModal';
import RangeSlider from '@ui-parts/RangeSlider';

import Checkbox from '@ui-elements/Checkbox';

import { AGE_DIVIDE_TYPES, DEFAULT_AGE } from '~/constants';

const BodyWrapper = styled.div`
  padding: 0 15px;
`;

const CheckBoxContainer = styled.div`
  & .MuiFormGroup-root {
    justify-content: center;
  }
`;

function AgeModal({ open, handleClose }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const age = useSelector((state) => state.qualifications.current.age);
  const [selectedAges, setSelectedAges] = useState([age.from, age.to]);
  const [isDivide, setIsDivide] = useState(age.divideType === AGE_DIVIDE_TYPES.TEN);
  const [errors, setErrors] = useState({
    isMinError: false,
    isMaxError: false,
    message: '',
    area: null,
  });

  useEffect(() => {
    setSelectedAges([age.from, age.to]);
    setIsDivide(age.divideType === AGE_DIVIDE_TYPES.TEN);
  }, [age]);

  return (
    <BasicModal
      open={open}
      titleProps={{
        titleLabel: t('quotas.deliveryTarget'),
        title: t('quotas.conditions.titles.age'),
        desc: t('quotas.modals.age.desc'),
      }}
      handleClose={() => {
        handleClose();
        // 選択状態を元に戻してあげる
        setSelectedAges([age.from, age.to]);
        setIsDivide(age.divideType === AGE_DIVIDE_TYPES.TEN);
      }}
      buttons={[
        <SaveButton
          key="button1"
          sx={{ width: 148, marginTop: 2 }}
          handleClick={() => {
            if (errors.isMinError || errors.isMaxError) return;
            dispatch({
              type: 'qualifications/changed',
              payload: {
                key: 'age',
                value: {
                  // 初期値で保存するとnullが入るのでデフォルト値も設定
                  from: selectedAges[0] ?? DEFAULT_AGE.FROM,
                  to: selectedAges[1] ?? DEFAULT_AGE.TO,
                  divideType: isDivide ? AGE_DIVIDE_TYPES.TEN : AGE_DIVIDE_TYPES.NONE,
                },
              },
            });
            handleClose();
          }}
          label={t('appCommon.setting')}
        />,
      ]}
      aboveButtons={
        <CheckBoxContainer>
          <Checkbox
            name="diveidAgeCheckbox"
            label={t('quotas.modals.age.divide')}
            checked={isDivide}
            handleChange={() => {
              setIsDivide(!isDivide);
            }}
            dataTestId="dividAgeCheckbox"
          />
        </CheckBoxContainer>
      }
      dataTestId="AgeModal"
      width="44%"
      scrollable={false}
    >
      <BodyWrapper>
        <RangeSlider
          min={DEFAULT_AGE.FROM}
          max={DEFAULT_AGE.TO}
          step={1}
          labels={[t('quotas.modals.age.lowerLimit'), t('quotas.modals.age.upperLimit')]}
          values={[selectedAges[0] ?? DEFAULT_AGE.FROM, selectedAges[1] ?? DEFAULT_AGE.TO]}
          width="100%"
          errors={errors}
          setErrors={setErrors}
          handleChange={(newValue) => {
            setSelectedAges(newValue);
          }}
        />
      </BodyWrapper>
    </BasicModal>
  );
}

AgeModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
};

export default AgeModal;
